/**
 * @description Fonction Test permettant de tester l'installation de la librairie
 *
 * @param   {String}  _name  une simple chaine
 *
 * @return  {String}
 */
export function sayHello(_name) {
  const name = "Hello " + _name;
  console.log(name);
  return name;
}
